<template>
  <div class="Task-modal-overlay">
    <transition name="modal-expand">
      <div v-if="isVisible" class="Task-modal-content" @click.stop>
        <div class="modal-content-long" @click.stop>
          <button class="modal-close-btn" @click="close" aria-label="Close">
            <font-awesome-icon :icon="['fas', 'window-close']" />
          </button>

          <div class="Task-modal-header">
            <span class="chapter-badge">{{ chapterName }}</span>
            <h5 class="Task-modal-title">Task No: {{ task.task_no }}</h5>
          </div>

          <div class="modal-body">
            <div class="description-block">
              <span class="field-label">Description</span>
              <p class="description-text">
                <template v-for="(part, index) in splitReference(task.description)" :key="index">
                  {{ part }}<br v-if="index < splitReference(task.description).length - 1" />
                </template>
              </p>
            </div>

            <div class="field-grid-section">
              <div class="field-grid">
                <div class="field-block">
                  <span class="field-label">MT/AT</span>
                  <span class="field-value">{{ task.manob }}</span>
                </div>
                <div class="field-block">
                  <span class="field-label">Scope</span>
                  <span class="field-value">{{ task.scope }}</span>
                </div>
                <div class="field-block">
                  <span class="field-label">Reference</span>
                  <span class="field-value">
                    <template v-for="(part, index) in splitReference(task.reference)" :key="index">
                      {{ part }}<br v-if="index < splitReference(task.reference).length - 1" />
                    </template>
                  </span>
                </div>
                <div class="field-block">
                  <span class="field-label">Assigned</span>
                  <span class="status-pill" :class="task.enabled ? 'pill-yes' : 'pill-no'">
                    {{ task.enabled ? 'Yes' : 'No' }}
                  </span>
                </div>
              </div>
            </div>

            <div class="progress-section">
              <div class="progress-row">
                <span class="field-label">Classroom (P1)</span>
                <span class="status-pill" :class="task.entry_P1 ? 'pill-yes' : 'pill-no'">
                  {{ task.entry_P1 ? 'Yes' : 'No' }}
                </span>
              </div>
              <div class="progress-row">
                <span class="field-label">Aircraft (P2)</span>
                <span class="status-pill" :class="task.entry_P2 ? 'pill-yes' : 'pill-no'">
                  {{ task.entry_P2 ? 'Yes' : 'No' }}
                </span>
              </div>
              <div class="progress-row">
                <span class="field-label">Trainee Sign Off</span>
                <span class="status-pill" :class="task.completed ? 'pill-yes' : 'pill-pending'">
                  {{ task.completed || 'Incomplete' }}
                </span>
              </div>
              <div class="progress-row">
                <span class="field-label">Instructor Sign Off</span>
                <span class="status-pill" :class="task.ins_so ? 'pill-yes' : 'pill-pending'">
                  {{ task.ins_so || 'Incomplete' }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    task: {
      type: Object,
      required: true
    },
    logbookId: {
      type: [String, Number],
      required: true
    },
    chapters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showInsTaskLongFormModal: true,
      taskData: [],
      isVisible: false,
    };
  },
  computed: {
    chapterName() {
      const chaptNo = this.task.chapt_no;
      const chapter = this.chapters.find((ch) => ch.chapt_no === chaptNo);
      return chapter ? `Chapter ${chaptNo}: ${chapter.name}` : `Chapter ${chaptNo}`;
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    splitReference(value) {
      if (!value) return [''];
      return String(value).split('\\');
    },
  },
  mounted() {
    this.isVisible = true;
  }

}
</script>

<style scoped>
.Task-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* Semi-transparent background */
  display: flex;
  justify-content: center;
  z-index: 1000;
  padding: 16px;
  box-sizing: border-box;
}

.Task-modal-content {
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
  /* Scale with the viewport instead of a fixed 50% - on a tablet/phone that
     50% was often narrower than the table below, cutting the description off. */
  width: min(560px, 100%);
  box-sizing: border-box;
  max-height: 87vh;
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 40px;
  /* #app sets text-align: center globally - override it so the header,
     description and fields all read left-aligned instead of centered. */
  text-align: left;
}

.modal-content-long {
  position: relative;
}

.modal-close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: background 0.15s ease;
  z-index: 1;
}

.modal-close-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

.Task-modal-header {
  background: linear-gradient(#a52c0d, #791e08);
  color: #ffffff;
  padding: 18px 20px;
  border-radius: 10px 10px 0 0;
}

.chapter-badge {
  display: inline-block;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  background: rgba(255, 255, 255, 0.18);
  padding: 3px 10px;
  border-radius: 12px;
  margin-bottom: 6px;
}

.Task-modal-title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
}

.modal-body {
  padding: 20px;
}

.field-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #8a8a8a;
  margin-bottom: 4px;
}

.description-block {
  background: #f6f8fb;
  border: 1px solid #e3e7ee;
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 18px;
}

.description-text {
  margin: 0;
  font-size: 15px;
  line-height: 1.5;
  color: #2c2c2c;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

.field-grid-section {
  background: #fafafa;
  border: 1px solid #ededed;
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 18px;
}

.field-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px 18px;
}

.field-block {
  min-width: 0;
}

.field-value {
  font-size: 15px;
  font-weight: 600;
  color: #333333;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.progress-section {
  background: #fafafa;
  border: 1px solid #ededed;
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.progress-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.progress-row .field-label {
  margin-bottom: 0;
}

.status-pill {
  display: inline-block;
  font-size: 13px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 12px;
  white-space: nowrap;
}

.pill-yes {
  background: #eaf7ec;
  color: #27ae60;
  border: 1px solid #27ae60;
}

.pill-no {
  background: #f2f2f2;
  color: #777777;
  border: 1px solid #cccccc;
}

.pill-pending {
  background: #fdf3e7;
  color: #b06a1c;
  border: 1px solid #e0a95c;
}

/* App.vue defines a global `span:hover { color: black !important; }` which
   otherwise flattens every label/pill/badge below to black on hover - restate
   each one's own color here so it stays put. */
.chapter-badge:hover {
  color: #ffffff !important;
}

.field-label:hover {
  color: #8a8a8a !important;
}

.field-value:hover {
  color: #333333 !important;
}

.pill-yes:hover {
  color: #27ae60 !important;
}

.pill-no:hover {
  color: #777777 !important;
}

.pill-pending:hover {
  color: #b06a1c !important;
}

@media (max-width: 480px) {
  .field-grid {
    grid-template-columns: 1fr;
  }

  .progress-row {
    flex-wrap: wrap;
  }
}
</style>
